
var jsonData = {
    'list': [
        {
            title: '2024年全国春季“村晚”示范展示点暨陕西·紫阳茶文旅系列活动', //标题
            cover: 'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/四季村晚/四季村晚/全国12个示范点/2024年全国春季“村晚”示范展示点暨陕西·紫阳茶文旅系列活动.png', // 封面图   
            url: 'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/四季村晚/四季村晚/全国12个示范点/2024年全国春季“村晚”示范展示点暨陕西·紫阳茶文旅系列活动~1.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '4月22日，2024年全国春季“村晚”示范展示点暨陕西·紫阳“茶乡飞歌·多彩紫阳”茶文旅系列活动在紫阳县向阳镇营梁村半亩茶园圆满举办。', //简介，需要换行的用"KADA" 分割
            time: '2024-4-22', //日期
            class: '1',  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '安康市紫阳县向阳镇营梁村',//报送单位
            standby1: '',//备用1 
        },
        {
            title: '2024年陕西省夏季“村晚”示范展示暨渭滨区石鼓镇茵香河村示范展演', //标题
            cover: 'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/四季村晚/四季村晚/省级20个示范点/宝鸡市渭滨区/石鼓镇茵香河村.png', // 封面图   
            url: 'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/四季村晚/四季村晚/省级20个示范点/宝鸡市渭滨区/石鼓镇茵香河村1.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '6月9日晚，宝鸡市渭滨区石鼓镇茵香河村灯火辉煌，人声鼎沸。这里，一场名为“大地欢歌”乡村文化活动年2024年陕西省夏季“村晚”示范展示暨渭滨区石鼓镇茵香河村示范展演活动正如火如荼地进行。', //简介，需要换行的用"KADA" 分割
            time: '2024-6-9', //日期
            class: '5',  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '渭滨区石鼓镇茵香河村',//报送单位
            standby1: '',//备用1 
        },
        {
            title: '2024年全国春季“村晚”示范展示点暨陕西·宁强“春溢宁强·茶山情歌”中国醉美茶文化旅游季活动', //标题
            cover: 'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/四季村晚/四季村晚/全国12个示范点/2024年全国春季“村晚”示范展示点暨陕西·宁强“春溢宁强·茶山情歌”中国醉美茶文化旅游季活动.png', // 封面图   
            url: 'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/四季村晚/四季村晚/全国12个示范点/2024年全国春季“村晚”示范展示点暨陕西·宁强“春溢宁强·茶山情歌”中国醉美茶文化旅游季活动.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '由文化和旅游部公共服务司主办，陕西省文化和旅游厅、中国文化馆协会、中共宁强县委、宁强县人民政府承办的2024年全国春季“村晚”示范展示点暨陕西·宁强“春溢宁强·茶山情歌”中国醉美茶文化旅游季活动将于2024年4月8日10:00在国家公共文化云全程直播。', //简介，需要换行的用"KADA" 分割
            time: '2024-4-8', //日期
            class: '1',  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '汉中市宁强县高寨子街道办肖家坝村',//报送单位
            standby1: '',//备用1 
        },
        {
            title: '“大地欢歌乡村行·产业润泽甜蜜梦”2024年全国春季“村晚”示范展示点暨阎良甜瓜产业文化旅游节', //标题
            cover: 'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/四季村晚/四季村晚/全国12个示范点/“大地欢歌乡村行·产业润泽甜蜜梦”2024年全国春季“村晚”示范展示点暨阎良甜瓜产业文化旅游节.jpg', // 封面图   
            url: 'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/四季村晚/四季村晚/全国12个示范点/“大地欢歌乡村行·产业润泽甜蜜梦”2024年全国春季“村晚”示范展示点暨阎良甜瓜产业文化旅游节.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '4月27日下午15：30，由文化和旅游部公共服务司主办，陕西省文化和旅游厅、中国文化馆协会、中共西安市阎良区委员会、西安市阎良区人民政府承办的“大地欢歌乡村行·产业润泽甜蜜梦”2024年全国春季“村晚”示范展示点暨阎良甜瓜产业文化旅游节将在陕西省西安市阎良区关山街道北冯村精彩上演。', //简介，需要换行的用"KADA" 分割
            time: '2024-4-27', //日期
            class: '1',  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '西安市阎良区关山街道北冯村',//报送单位
            standby1: '',//备用1 
        },
        {
            title: '“绿都山水·大地欢歌”2024年陕西省夏季“村晚”示范展演暨陕西·宁陕文旅系列活动', //标题
            cover: 'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/四季村晚/四季村晚/省级20个示范点/安康市宁陕县/“绿都山水·大地欢歌”2024年陕西省夏季“村晚”示范展演暨陕西·宁陕文旅系列活动.jpg', // 封面图   
            url: 'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/四季村晚/四季村晚/省级20个示范点/安康市宁陕县/“绿都山水·大地欢歌”2024年陕西省夏季“村晚”示范展演暨陕西·宁陕文旅系列活动.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '夏夜山风，欢歌绵长。6月29日，由陕西省文化和旅游厅主办，陕西省文化馆等单位承办的“绿都山水·大地欢歌”2024年陕西省夏季“村晚”示范展演暨陕西·宁陕文旅系列活动在宁陕县筒车湾镇精彩上演。秀美景色映衬下热闹展开的群众文艺活动，吸引了众多周边村民、游客前往观看。', //简介，需要换行的用"KADA" 分割
            time: '2024-6-29', //日期
            class: '5',  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '安康市宁陕县筒车湾镇许家城村',//报送单位
            standby1: '',//备用1 
        },
        {
            title: '“相约太白山共享清凉季”全国夏季“村晚”宝鸡市眉县汤峪镇汤峪村示范展演', //标题
            cover: 'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/四季村晚/四季村晚/全国12个示范点/“相约太白山共享清凉季”全国夏季“村晚”宝鸡市眉县汤峪镇汤峪村示范展演~1.jpg', // 封面图   
            url: 'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/四季村晚/四季村晚/全国12个示范点/“相约太白山共享清凉季”全国夏季“村晚”宝鸡市眉县汤峪镇汤峪村示范展演~1.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '6月27日，以“相约太白山 共享清凉季”为主题的全国夏季“村晚”示范展示活动在宝鸡市眉县汤峪镇汤峪村太白山国家森林公园大门口成功举办。本次活动由文化和旅游部公共服务司主办，陕西省文化和旅游厅、中国文化馆协会、中共眉县县委、眉县人民政府承办，陕西省文化馆、宝鸡市文化和旅游局、太白山旅游区管理委员会协办，文化和旅游部全国公共文化发展中心、宝鸡市群艺馆提供支持。', //简介，需要换行的用"KADA" 分割
            time: '2024-6-27', //日期
            class: '2',  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '宝鸡市眉县汤峪镇汤峪村',//报送单位
            standby1: '',//备用1 
        },
        {
            title: '“源来周至 多来多福”2024全国夏季“村晚”示范展示暨周至县夏日乡村文化旅游季活动', //标题
            cover: 'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/四季村晚/四季村晚/全国12个示范点/“源来周至 多来多福”2024全国夏季“村晚”示范展示暨周至县夏日乡村文化旅游季活动.jpg', // 封面图   
            url: 'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/四季村晚/四季村晚/全国12个示范点/“源来周至 多来多福”2024全国夏季“村晚”示范展示暨周至县夏日乡村文化旅游季活动.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '7月12日晚，由文化和旅游部公共服务司主办，陕西省文化和旅游厅、中国文化馆协会、西安市文化和旅游局、中共西安市周至县委、周至县人民政府承办的“源来周至 多来多福”2024全国夏季“村晚”示范展示暨周至县夏日乡村文化旅游季活动，在西安周至水街——烟火巷子启动。', //简介，需要换行的用"KADA" 分割
            time: '2024-7-12', //日期
            class: '2',  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '陕西西安周至水街',//报送单位
            standby1: '',//备用1 
        },
        {
            title: '“神奇神木·魅力古堡”2024年全国夏季“村晚”示范展示暨高家堡消夏文旅活动', //标题
            cover: 'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/四季村晚/四季村晚/全国12个示范点/“神奇神木·魅力古堡”2024年全国夏季“村晚”示范展示暨高家堡消夏文旅活动.jpg', // 封面图   
            url: 'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/四季村晚/四季村晚/全国12个示范点/“神奇神木·魅力古堡”2024年全国夏季“村晚”示范展示暨高家堡消夏文旅活动.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '7月22日，“神奇神木·魅力古堡”2024年全国夏季“村晚”展演展示暨高家堡消夏文旅活动成功举办。活动以古堡为舞台，以乡村文化为灵魂，融合了传统与现代，展现出一幅生动鲜活的乡村生活画卷。', //简介，需要换行的用"KADA" 分割
            time: '2024-7-22', //日期
            class: '2',  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '神木市高家堡镇高家堡村',//报送单位
            standby1: '',//备用1 
        },

    ]
}
export default jsonData


// WEBPACK FOOTER //
// ./src/api/datalist.js